import Vue from 'vue';
import VueI18n from 'vue-i18n';
import {en} from './i18ns/en';
import {ko} from './i18ns/ko';
import {ja} from './i18ns/ja';
import {zh} from './i18ns/zh';

Vue.use(VueI18n);

const messages = {en, ko, ja, zh};

export const i18n = new VueI18n(
    {
        locale: 'en',
        fallbackLocale: 'en',
        messages
    });
